import { Checkbox, FormControlLabel, Grid, useEventCallback } from '@mui/material';
import { memo, useEffect } from 'react';
import { FormikTouched, FormikErrors } from 'formik';
import CivilStatusList from 'shell/components/shared/civil-status-list';
import { CivilStatusVM } from 'subscription/view-models/common-interface-subscription';

interface FormCivilStatusProps {
  disabled?: boolean;
  errors?: FormikErrors<CivilStatusVM>;
  touched?: FormikTouched<CivilStatusVM>;
  values?: CivilStatusVM;
  onChange: (key: keyof CivilStatusVM, value: CivilStatusVM[keyof CivilStatusVM]) => void;
}

const FormCivilStatusComponent = ({
  disabled,
  values,
  onChange,
  errors,
  touched,
}: FormCivilStatusProps): React.ReactElement => {
  const handleCivilStatusListChange = useEventCallback((element: string | undefined) => {
    onChange('status', element);
  });

  useEffect(() => {
    if (values?.available) {
      onChange('status', undefined);
    }
  }, [values?.available]);

  return (
    <Grid container spacing={1}>
      <Grid item xs={12} md={6}>
        <CivilStatusList
          label="Stato civile"
          aria-label="Stato civile"
          value={values?.status || ''}
          onChange={handleCivilStatusListChange}
          error={touched?.status && Boolean(errors?.status)}
          disabled={disabled || values?.available}
        />
      </Grid>
      <Grid item xs>
        <FormControlLabel
          control={
            <Checkbox
              id="availableStatus"
              checked={values?.available || false}
              onChange={() => onChange('available', !values?.available)}
              inputProps={{ 'aria-label': 'Stato civile non disponibile' }}
              disabled={disabled}
            />
          }
          label="Stato civile non disponibile"
        />
      </Grid>
    </Grid>
  );
};

FormCivilStatusComponent.displayName = 'Form civil status component';

const FormCivilStatus = memo(FormCivilStatusComponent);

export default FormCivilStatus;
